var map = {
	"./decidim/avatar-multiuser.png": 2250,
	"./decidim/brands/google.svg": 28229,
	"./decidim/cc-badge.png": 4820,
	"./decidim/decidim-logo.svg": 74744,
	"./decidim/default-avatar.svg": 75424,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 56988,
	"./decidim/icons.svg": 92027,
	"./decidim/pattern.png": 92956,
	"./decidim/placeholder-card-g.svg": 83097,
	"./decidim/placeholder-card-l.svg": 91442,
	"./decidim/placeholder.jpg": 37585,
	"./decidim/remixicon.symbol.svg": 44821,
	"./decidim/vendor/leaflet/layers-2x.png": 93492,
	"./decidim/vendor/leaflet/layers.png": 31123,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 55118,
	"./decidim/vendor/leaflet/marker-icon.png": 42165,
	"./decidim/vendor/leaflet/marker-shadow.png": 63098,
	"./decidim/vendor/social-share-button/douban.svg": 44036,
	"./decidim/vendor/social-share-button/email.svg": 66209,
	"./decidim/vendor/social-share-button/facebook.svg": 20839,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 73337,
	"./decidim/vendor/social-share-button/hacker_news.svg": 84337,
	"./decidim/vendor/social-share-button/linkedin.svg": 85217,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 19842,
	"./decidim/vendor/social-share-button/pinterest.svg": 94103,
	"./decidim/vendor/social-share-button/reddit.svg": 44987,
	"./decidim/vendor/social-share-button/telegram.svg": 21278,
	"./decidim/vendor/social-share-button/tumblr.svg": 6013,
	"./decidim/vendor/social-share-button/twitter.svg": 18288,
	"./decidim/vendor/social-share-button/vkontakte.svg": 64414,
	"./decidim/vendor/social-share-button/wechat.svg": 80473,
	"./decidim/vendor/social-share-button/whatsapp.svg": 53601,
	"./decidim/vendor/social-share-button/x.svg": 66857,
	"./decidim/vendor/social-share-button/xing.svg": 5671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10683;